export default "__VITE_ASSET__$MfxU2dt__"